import { useMemo } from 'react';
import { Link as DomLink, NavLink } from "react-router-dom";
import { useNavigator } from '../../utilities/navigator';

const Link = ({ href = '/', params = {}, parseQueryParams = true, queryParamKey, children, raw, route: propRoute, navLink, title, exact, onClick, noScroll, ...props }) => {
	const { getRoute, generateRoutePath } = useNavigator();


	const { Component, computedProps } = useMemo(() => {
		let Component = navLink ? NavLink : DomLink;

		if(raw) {
			const isExternal = href && href.startsWith('http');
			return {
				Component: isExternal ? 'a' : Component,
				computedProps: {
					title: title ?? 'Link',
					children: children,
					to: isExternal ? undefined : href,
					href: isExternal ? href : undefined,
					onClick: onClick,
				}
			}
		}

		const route = propRoute ?? getRoute(href);
		const to = route ? generateRoutePath({ route, params, parseQueryParams, queryParamKey }) : href ?? false;
		const routeTitle = (route?.title ?? route?.head?.title) ?? null;

		return {
			Component,
			computedProps: route ? {
				title: title ?? routeTitle,
				to,
				children: children ?? routeTitle,
				exact: typeof exact !== 'undefined' ? exact : ((!!navLink && route.exact) || undefined),
				onClick: (e) => {
					if(onClick) {
						onClick(e);
					}
					if(!noScroll) {
						window.scrollTo(0,0);
					}
				}
			} : false,
		}
	}, [href, params, parseQueryParams, queryParamKey, propRoute, navLink, raw, title, exact, onClick, noScroll])

	if(computedProps) {
		return <Component {...props} {...computedProps} />
	}
	else {
		return null;
	}

}

export default Link